"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("@osmosys/models");
exports.TIMEZONE_OPTIONS = models_1.TIMEZONES.map(timezone => {
    return {
        label: `${timezone}`,
        value: timezone,
    };
});
exports.findTimezoneOption = (integrationTimezone) => integrationTimezone &&
    exports.TIMEZONE_OPTIONS.find(timezone => timezone.value === integrationTimezone);
//# sourceMappingURL=timezone.js.map